import { Component, OnInit } from '@angular/core';
import { Site, Customer, Train, NavEntity } from '../../models';
import { Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Deviation } from '../../models/deviation';
import { StarmsClientProvider } from '../../providers/starms-client/starms-client';
import { NavParams, NavController, ModalController } from 'ionic-angular';
import { InstrumentHealthPage } from '../../pages/instrument-health/instrument-health';

import * as moment from 'moment';

@Component({
  selector: 'instrument-health-overview',
  templateUrl: 'instrument-health-overview.html'
})
export class InstrumentHealthOverviewComponent implements OnInit {

  nav: NavEntity;
  deviationsList: Array<Deviation> = [];
  deviationsAvailable: boolean;
  newDeviationsCount: number;
  newDeviationsList: Array<Deviation> = [];
  deviationsLoaded = false;
  ready: boolean;

  current: Site | Customer | Train;
  trainId: number;
  subscription: Subscription;
  subscription2: Subscription;

  trainStatus: any;

  constructor(
    public navCtrl: NavController,
    private starmsClientService: StarmsClientProvider,
    public navParams: NavParams,
    private modalCtrl: ModalController
  ) {
  }

  ngOnInit(): void {
    this.nav = this.navParams.data;
    this.ready = false;
    this.getDeviations();
  }

  getDeviations(): void {

    this.subscription2 = forkJoin(
      this.starmsClientService.get(['myhealth', 'deviations'
      ], {
        trainId: this.nav.getId(),
        from: '2016-01-01',
        to: moment().format('YYYY-MM-DD HH:mm:ss'),
        status: 0,
        application: 8
      }),
      this.starmsClientService.get(['Trains', this.nav.getId(), 'status'
      ])
    ).subscribe(
      ([deviations, status]) => {
        for (const dev of deviations) {

          const titleRegex = /\([A-Za-z0-9]SC[A-Za-z0-9]\)/g;

          if ((titleRegex.test(dev.title) && dev.caseId) || (dev.deviationFaultType === 'Sensor Fault' && dev.tagAlias)) {
            // (dev.title.includes('(H SC)') || dev.title.includes('(M SC)') || dev.title.includes('(L SC)')) && dev.caseId

            // deserializes deviation and converts the Dates to ignore timezone
            const newDev = new Deviation().deserialize(dev);

            // removes the parenthesis part of the title
            newDev.title = newDev.title.substring(7, newDev.title.length);

            // transforms Tag Alias string into an array
            newDev.tagAlias = newDev.tagAlias.split(', ');

            // initializes Tag Alias Array
            newDev.tagAliasArray = [];

            this.deviationsList.push(newDev);

            this.deviationsAvailable = true;
          }

          if (this.deviationsList.length === 0) {
            this.deviationsAvailable = false;
            this.newDeviationsCount = 0;
            this.ready = true;

          } else {
            this.deviationsLoaded = true;
            this.getNew();
            this.ready = true;
          }
          this.trainStatus = status;
        }
      }
    );
  }

  getNew() {

    this.newDeviationsList = this.deviationsList.filter(dev => {
      if (dev.status.includes('New') || dev.status.includes('Acknowledged')) {
        return dev;
      }
    });

    if (this.newDeviationsList.length === 0) {
      this.newDeviationsCount = 0;

    } else {
      this.newDeviationsList = this.newDeviationsList
        .filter(function (obj, index, self) {
          return index === self
            .findIndex(function (t) { return t.tagAlias[0] === obj.tagAlias[0]; });
        });
      this.newDeviationsCount = this.newDeviationsList.length;
    }

  }

  onInstrumentHealthClick() {
    this.trainId = this.nav.getId();

    this.modalCtrl
      .create(InstrumentHealthPage, {
        data: {
          id: this.nav.getId(),
          type: this.nav.getType()
        }
      })
      .present();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/instrument-health-overview/instrument-health-overview.ts